<template>
    <div>
        <head-nav></head-nav>

        <div class="form-reset">
            <img src="../../img/mission-logo.png" style="max-width:300px; margin-left: -11px">
            <br>
            <br>
            <span style="font-family:berleno; padding-top:15px;padding-bottom:15px">
                Please enter your email, and follow the instructions.
            </span>
            <br>
            <br>
            <form class="login-form" @submit.prevent="restPassword">
                <input type="text" name="username" placeholder="Email Address" style="font-family:berleno; "
                    v-model="forgot.email">
                <button class="btn btn-dark" name="submit" type="submit">Submit</button>
            </form>
            <br>
            <router-link class="message" to="/login" style="font-family:berleno">Back to login</router-link>
            <br>
            <br>
            <a class="message" href="/the-magazine" style="font-family:berleno">Back to
                website</a>
        </div>
        <info></info>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import headNav from '../../components/navBar'
import info from '../../components/info';
import { auth } from '@/firebase';
import swal from 'sweetalert';
export default {
    components: {
        headNav,
        info

    },
    data() {
        return {

        }
    },
    methods: {
        async restPassword() {
            try {
                await auth.sendPasswordResetEmail(this.forgot.email).then(() => {
                    swal({
                        title: "Success",
                        text: "Please check your email",
                        icon: "success",
                        buttons: false,
                        timer: 3000
                    }).then(() =>{
                        this.$router.push('/login');
                    });;
                })
            } catch (error) {
                swal({
                    title: "Error",
                    text: JSON.stringify(error.message),
                    icon: "error",
                    buttons: false,
                    timer: 3000,
                });
            }

        },
        //TODO:
        /*    async restPassword(){
               InPlayer.Account.requestNewPassword({
                   email: this.forgot.email,
                   merchantUuid: this.inplayerId
               })
               .then(data => {
                   swal({
                       title: data.data.message,
                       text: data.data.message,
                       icon: "success",
                       buttons: false,
                       timer: 3000
                   });
                   this.$router.push("/reset-password")
                   console.log(data)
               })
               .catch((error) => { 
                       swal({
                           title: "Error",
                           text:JSON.stringify(error.response.data.errors),
                           icon: "error",
                           buttons: false,
                           timer: 1500,
                       });                   
                   })
           
             
           }, */
        ...mapActions('inPlayer', [
            'lostPassword'
        ])
    },
    computed: {
        ...mapState('inPlayer', [
            'forgot',
            'status',
            'inplayerId'
        ])
    },

}
</script>
<style>
.form-reset {
    position: relative;
    z-index: 1;
    background: #FFFFFF;
    max-width: 500px;
    max-height: 500px;
    margin: 20px auto 40px;
    padding: 45px;
    text-align: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}

.form-reset input {
    font-family: 'lemon_milkregular';
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 15px;
    box-sizing: border-box;
    font-size: 14px;
}

.form-reset button {
    font-family: 'lemon_milkregular';
    text-transform: uppercase;
    outline: 0;
    width: 100%;
    border: 0;
    padding: 15px;
    color: #FFFFFF;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
}


.form-reset .message {
    margin: 15px 0 0;
    color: #212529;
    font-size: 15px;
    text-decoration: none;
}
</style>